import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

class Tabs extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { activeTab: this.props.defaultTab }
  }

  onTabSelected(tab, index) {
    if (!tab.disabled && index !== this.state.activeTab) {
      this.setState({ activeTab: index })

      if (this.props.onTabSelected) {
        this.props.onTabSelected(index)
      }
    }
  }

  render() {
    const {
      children,
      values,
      fullWidth,
      tabRowActive,
      contentStyling,
      dataCy,
    } = this.props
    const classNames = [midas.tab, fullWidth && midas.tabBlock]
      .filter(val => val)
      .join(' ')
    return (
      <div id="tabs" data-cy={dataCy}>
        <section>
          {tabRowActive && (
            <ul className={classNames}>
              {values.map((tab, index) => (
                <li
                  key={tab.value}
                  className={[
                    midas.tabItem,
                    index === this.state.activeTab && midas.active,
                  ]
                    .filter(val => val)
                    .join(' ')}
                >
                  <a //eslint-disable-line
                    title={tab.title}
                    style={
                      tab.disabled
                        ? { color: 'lightgrey', cursor: 'default' }
                        : null
                    }
                    role="navigation"
                    onClick={() => this.onTabSelected(tab, index)}
                  >
                    {tab.value}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </section>
        <section>
          {values.map(
            (tab, index) =>
              !tab.disabled &&
              index === this.state.activeTab && (
                <article key={tab.value} style={contentStyling}>
                  {tab.content}
                </article>
              ),
          )}
        </section>
        {children}
      </div>
    )
  }
}

Tabs.propTypes = {
  children: PropTypes.node,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.node.isRequired,
      disabled: PropTypes.bool,
      title: PropTypes.string,
      content: PropTypes.node,
    }),
  ),
  fullWidth: PropTypes.bool,
  defaultTab: PropTypes.number,
  onTabSelected: PropTypes.func,
  tabRowActive: PropTypes.bool,
  contentStyling: PropTypes.object,
  dataCy: PropTypes.string,
}
Tabs.defaultProps = {
  children: null,
  values: [],
  fullWidth: false,
  defaultTab: 0,
  onTabSelected: () => {},
  tabRowActive: true,
  contentStyling: null,
  dataCy: null,
}

export default Tabs
